import React, { useCallback, useEffect, useState } from "react";
import { callAPI } from "../../../axios";
import { CircularProgress, Tooltip } from "@mui/material";
import Custom_Paingation from "../../core/BaseComponents/Custom_Paingation";
import TableWrapper from "../../core/BaseComponents/TableWrapper/TableWrapper";
import dayjs from "dayjs";
import { getChainIdLS } from "../../../utils/utils";
import { debounce } from "lodash";
import ActivityLogsPopup from "./ActivityLogsPopup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";

function ActivityLogs() {
  const [activityList, setActivityList] = useState([]);
  const [selectedPage, setSelectedPage] = useState(1);
  const [totalPageCount, setTotalPageCount] = useState(1);
  const [paginationError, setPaginationError] = useState("");
  const [inputPageValue, setInputPageValue] = useState(1);
  const [searchText, setSearchText] = useState("");

  const [loader, setLoader] = useState(false);
  const [showActivityLogPopup, setShowActivityLogPopup] = useState(false);
  const [rowData, setRowData] = useState(null);

  const { chainId } = useSelector((state) => state.chainIdReducer);

  const recordsPerPage = 15;

  const getActivityListApi = () => {
    setLoader(true);
    callAPI(
      `/search-audit-log?pageNo=${selectedPage}&recordsPerPage=${recordsPerPage}`,
      "POST",
      {
        action: searchText,
        chainId: getChainIdLS(),
      }
    )
      .then((response) => {
        setTotalPageCount(response?.totalPages ? response?.totalPages : 1);
        setPaginationError("");
        setActivityList(response?.auditLogResponse);
        setLoader(false);
      })
      .catch((err) => {
        console.warn(err.message);
        setLoader(false);
      });
  };

  useEffect(() => {
    getActivityListApi();
  }, [selectedPage, searchText, chainId]);

  useEffect(() => {
    setSelectedPage(1);
    setTotalPageCount(1);
    setInputPageValue(1);
    setPaginationError("");
  }, [searchText]);

  const renderActionIcon = (row) => {
    return (
      <Tooltip
        // placement="top"
        title="Logs"
        arrow
      >
        <span>
          <FontAwesomeIcon
            icon={faInfoCircle}
            onClick={() => {
              setRowData(row);
              setShowActivityLogPopup(true);
            }}
            style={{ color: "#913aff" }}
            className="cursor-pointer error-icon"
          />
        </span>
      </Tooltip>
    );
  };

  const columns = [
    {
      field: "performedAt",
      headerName: "Performed On",
      flex: 1,
      row: true,
      renderCell: (row) => (
        <p className="mb-0">
          {dayjs(row.createdOn).format("DD MMM YYYY | HH:mm")}
        </p>
      ),
    },
    { field: "performedBy", headerName: "Performed By", flex: 1 },
    { field: "action", headerName: "Action Performed", flex: 1 },
    {
      field: "actionCell",
      row: true,
      headerName: "Actions Tracker",
      flex: 0.5,
      renderCell: renderActionIcon,
      sortDirection: false,
      disableSortIcon: true,
    },
  ];

  //Pagination Handle changer
  const onPageChange = (event, value) => {
    setInputPageValue(value);
    setPaginationError("");
    setSelectedPage(value);
  };

  // Delay search by 600ms
  const delayedSearch = useCallback(
    debounce((searchText) => setSearchText(searchText.target.value), 600),
    []
  );

  return (
    <div className="row config-hotel config-management-form">
      <div className="col-12 left-column">
        {loader && (
          <div className="circular-progress">
            <CircularProgress />
          </div>
        )}
        <div className="hotel-list">
          <div className="flex-items-between mb-3">
            <b>Audits Logs:</b>
            <div className="form-group-hotel mb-0">
              <div className={`floating-label`}>
                <input
                  id="searchAction"
                  maxLength={10}
                  placeholder=""
                  className="form-control"
                  onChange={delayedSearch}
                />
                <label htmlFor="searchAction">Search Action Performed...</label>
              </div>
              {/* {searchTextValidation && (
              <small className="required">{searchTextValidation}</small>
            )} */}
            </div>
          </div>
          <TableWrapper
            data={activityList}
            columns={columns}
            noPagination={true}
            // module="partner-config"
          />
          <Custom_Paingation
            selectedPage={selectedPage}
            totalPageCount={totalPageCount}
            paginationError={paginationError}
            inputPageValue={inputPageValue}
            setSelectedPage={setSelectedPage}
            setPaginationError={setPaginationError}
            setInputPageValue={setInputPageValue}
            onPageChange={onPageChange}
          />
        </div>
        <ActivityLogsPopup
          onClose={() => setShowActivityLogPopup(false)}
          rowData={rowData}
          isOpen={showActivityLogPopup}
        />
      </div>
    </div>
  );
}

export default ActivityLogs;
